export const DASHBOARD_TEXTS = {
  filterByUserAndResource: {
    labelUser: "Users",
    labelResource: "Resources",
    placeholder: "Filter by User, Email or Workspace Name"
  }
};
